import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Home.css";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { t } from "../i18n";

/* ---------- DATA ---------- */
const attractions = [
  {
    title: "อ.เมืองน่าน",
    img: "https://img.wongnai.com/p/1600x0/2018/12/07/963e17dcf6cf43909286d5190002218a.jpg",
    url: "https://www.google.com/search?q=เที่ยวอำเภอเมืองน่าน",
  },
  {
    title: "อ.ปัว",
    img: "https://img.wongnai.com/p/624x0/2018/08/25/ec877a4824ce4004a48c4e5961cfb115.jpg",
    url: "https://www.google.com/search?q=เที่ยวอำเภอปัว+น่าน",
  },
  {
    title: "อ.บ่อเกลือ",
    img: "https://img.wongnai.com/p/1600x0/2021/05/06/893ab6de8a354cab9dcb27a41c371baa.jpg",
    url: "https://www.google.com/search?q=เที่ยวอำเภอบ่อเกลือ+น่าน",
  },
  {
    title: "อ.นาน้อย",
    img: "https://img.wongnai.com/p/1600x0/2020/01/02/6c8c62d5352e4adfab0d8a807b00ef4f.jpg",
    url: "https://www.google.com/search?q=เที่ยวอำเภอนาน้อย+น่าน",
  },
  {
    title: "อ.ท่าวังผา",
    img: "https://img.wongnai.com/p/1600x0/2020/09/25/72e79115f7504de7830769a7d7df00bc.jpg",
    url: "https://www.google.com/search?q=เที่ยวอำเภอท่าวังผา+น่าน",
  },
];

const rooms = [
  {
    id: 1,
    nameKey: "roomSingle",
    guestsNum: "1-2",
    price: "400 ฿",
    img: "https://eurngkum.com/wp-content/uploads/2021/05/gallery-16.jpg",
  },
  {
    id: 2,
    nameKey: "roomDouble",
    guestsNum: "2",
    price: "600 ฿",
    img: "https://eurngkum.com/wp-content/uploads/2021/05/gallery-12.jpg",
  },
  {
    id: 3,
    nameKey: "roomSpecial",
    guestsNum: "2-3",
    price: "700 ฿",
    img: "https://eurngkum.com/wp-content/uploads/2021/05/gallery-01.jpg",
  },
];

export default function Home() {
  const { lang } = useLanguage();
  return (
    <div>
      {/* HERO SECTION */}
      <div className="hero-section position-relative text-white">
        <img
          src="https://eurngkum.com/wp-content/uploads/2021/05/slide-01.jpg"
          className="w-100 hero-image"
          alt="hotel"
          style={{ minHeight: "400px", objectFit: "cover" }}
        />
        <div className="hero-overlay"></div>

        <div className="hero-title">
          <h1 className="display-4 fw-bold">EURNGKUM</h1>
          <h2>Guest House</h2>
        </div>

        <div className="hero-desc">
          <p>{t(lang, "heroDesc")}</p>
          <Link to="/rooms">
            <button className="btn btn-light mt-3 px-4 rounded-pill">
              {t(lang, "bookRoomBtn")}
            </button>
          </Link>
        </div>
      </div>

      {/* --- ROOM LIST SECTION --- */}
      <RoomList lang={lang} />

      {/* ATTRACTIONS */}
      <AttractionsSlider lang={lang} />

      {/* CONTACT & MAP */}
      <ContactSection lang={lang} />
    </div>
  );
}

/* ---------- ROOM LIST COMPONENT ---------- */
function RoomList({ lang }) {
  return (
    <div className="py-5" style={{ backgroundColor: "#F0EFEF" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">{t(lang, "roomPriceTitle")}</h2>
        </div>

        <div className="row row-cols-1 row-cols-md-3 g-5 justify-content-center">
          {rooms.map((room) => (
            <div className="col" key={room.id}>
              <div className="room-card-clean">
                <div className="room-image-wrapper">
                  <img src={room.img} alt={t(lang, room.nameKey)} className="room-img" />
                </div>
                <div className="room-info-container mt-3">
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="text-start">
                      <h5 className="room-name-text mb-0">{t(lang, room.nameKey)}</h5>
                      <span className="room-sub-text">{room.guestsNum} {t(lang, "guestsPer")}</span>
                    </div>
                    <div className="text-end">
                      <h5 className="room-price-text mb-0">{room.price}</h5>
                      <span className="room-sub-text">{t(lang, "perNightUnit")}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <p className="text-muted">{t(lang, "amenitiesNote")}</p>
        </div>
      </div>
    </div>
  );
}

/* ---------- ATTRACTIONS SLIDER ---------- */
function AttractionsSlider({ lang }) {
  return (
    <div className="py-5" style={{ backgroundColor: "#F0EFEF" }}>
      <div className="container text-center">
        <h2 className="mb-3 section-title">{t(lang, "attractionsTitle")}</h2>
        <p className="mb-5 text-muted mx-auto" style={{ maxWidth: "700px" }}>
          {t(lang, "attractionsDesc")}
        </p>

        <div className="row g-4 justify-content-center">
          {attractions.map((item, index) => (
            <div className="col-md-4 col-lg-2-4" key={index}>
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div className="attraction-item-wrapper attraction-hover">
                  <div className="attraction-label mb-2 text-start px-1">
                    {item.title}
                  </div>
                  <div className="attraction-img-container">
                    <img
                      src={item.img}
                      alt={item.title}
                      className="attraction-img-fluid"
                    />
                    {/* ไอคอน overlay เมื่อ hover */}
                    <div className="attraction-overlay">
                      <span className="attraction-overlay-text">{t(lang, "seeInfo")}</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ---------- CONTACT SECTION ---------- */
function ContactSection({ lang }) {
  return (
    <div className="py-5" style={{ backgroundColor: "#fff" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">{t(lang, "contactTitle")}</h2>
        </div>

        <div className="row g-4 align-items-stretch">
          {/* แผนที่ */}
          <div className="col-md-7">
            <div
              className="rounded overflow-hidden shadow-sm"
              style={{ height: "400px" }}
            >
              <iframe
                title="แผนที่โรงแรมเอื้องคำ"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.746!2d100.766026!3d18.7839842!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x312793fd8f73cf5d%3A0x2e565c1958cb9a9!2sEuangkham%20Hotel!5e0!3m2!1sth!2sth!4v1"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          {/* ข้อมูลติดต่อ */}
          <div className="col-md-5 d-flex">
            <div
              className="p-4 rounded w-100"
              style={{ backgroundColor: "#F0EFEF" }}
            >
              <h5 className="fw-bold mb-4" style={{ color: "#3a3a3a" }}>
                {t(lang, "contactHotel")}
              </h5>

              <div className="mb-3 d-flex gap-3">
                <span style={{ fontSize: "1.2rem" }}>📍</span>
                <div>
                  <div className="fw-semibold" style={{ color: "#555" }}>{t(lang, "contactAddress")}</div>
                  <div className="text-muted" style={{ fontSize: "0.95rem" }}>
                    319 หมู่ 3 ต.ผาสิงห์ อ.เมือง<br />
                    จ.น่าน 55000
                  </div>
                </div>
              </div>

              <div className="mb-3 d-flex gap-3">
                <span style={{ fontSize: "1.2rem" }}>📞</span>
                <div>
                  <div className="fw-semibold" style={{ color: "#555" }}>{t(lang, "contactPhone")}</div>
                  <div>
                    <a
                      href="tel:+6654771885"
                      className="text-muted text-decoration-none d-block"
                      style={{ fontSize: "0.95rem" }}
                    >
                      054-771885
                    </a>
                    <a
                      href="tel:+6654775817"
                      className="text-muted text-decoration-none d-block"
                      style={{ fontSize: "0.95rem" }}
                    >
                      054-775817
                    </a>
                  </div>
                </div>
              </div>

              <div className="mb-3 d-flex gap-3">
                <span style={{ fontSize: "1.2rem" }}>📱</span>
                <div>
                  <div className="fw-semibold" style={{ color: "#555" }}>{t(lang, "contactMobile")}</div>
                  <div>
                    <a
                      href="tel:+66818831430"
                      className="text-muted text-decoration-none d-block"
                      style={{ fontSize: "0.95rem" }}
                    >
                      081-8831430
                    </a>
                    <a
                      href="tel:+66898525570"
                      className="text-muted text-decoration-none d-block"
                      style={{ fontSize: "0.95rem" }}
                    >
                      089-8525570
                    </a>
                  </div>
                </div>
              </div>

              <div className="mb-4 d-flex gap-3">
                <span style={{ fontSize: "1.2rem" }}>🌐</span>
                <div>
                  <div className="fw-semibold" style={{ color: "#555" }}>{t(lang, "contactWebsite")}</div>
                  <a
                    href="https://eurngkum.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-muted text-decoration-none"
                    style={{ fontSize: "0.95rem" }}
                  >
                    eurngkum.com
                  </a>
                </div>
              </div>

              <a
                href="https://maps.app.goo.gl/3DC37JDnhXyLmG8R6"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-dark w-100 rounded-pill"
              >
                {t(lang, "openInMaps")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}